import {
  BaseIcon
} from "./chunk-Z3LMOCJ7.mjs";

// src/icons/networks/NetworkTron.tsx
import { forwardRef } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var NetworkTron = forwardRef(
  ({ variant = "mono", ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M3.577 2.206a.63.63 0 0 1 .615-.188l13.226 3.238q.12.028.219.102l2.691 1.963a.63.63 0 0 1 .15.859l-9.259 13.546a.625.625 0 0 1-1.108-.145L3.45 2.837a.63.63 0 0 1 .126-.63M5.76 5.59l4.622 13.013.76-6.743zm6.62 6.487-.772 6.86 6.537-9.566zm6.355-4.367-4.212 1.977 2.822-2.99zm-2.662-1.492L5.79 3.7l6.029 7.02z",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "#C4342B",
      d: "M3.577 2.206a.63.63 0 0 1 .615-.188l13.226 3.238q.12.028.219.102l2.691 1.963a.63.63 0 0 1 .148.859l-9.258 13.546a.625.625 0 0 1-1.109-.145L3.452 2.837a.63.63 0 0 1 .125-.63M5.76 5.59l4.622 13.013.76-6.743zm6.62 6.487-.772 6.86 6.537-9.566zm6.355-4.367L14.52 9.686l2.824-2.99zm-2.662-1.492L5.79 3.7l6.029 7.02z",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) }) })
);
NetworkTron.displayName = "tron";
var NetworkTron_default = NetworkTron;

export {
  NetworkTron_default
};
